/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {useIsMobile} from "../../../table/Table";
import {DocumentRowSkeletonMobile} from "./DocumentRowSkeletonMobile";
import {DocumentRowHeaderSkeleton} from "./DocumentRowHeaderSkeleton";
import {DocumentRowSkeleton} from "./DocumentRowSkeleton";

export const DocumentSkeleton = () => {
    const isMobile = useIsMobile();

    return isMobile ?
        <>{[...Array(5)].map((item, i) => <DocumentRowSkeletonMobile key={i}/>)}</>
        :
        <><DocumentRowHeaderSkeleton/>{[...Array(5)].map((item, i) => <DocumentRowSkeleton key={i}/>)}</>
}

